import { Divider } from '@mui/material';
import { Stack } from '@mui/system';
import Input from '../../Input';
import Output from '../../Output';
import { useParams } from 'react-router-dom';

const GeneratorContentPage: React.FC = () => {
  const { url } = useParams();
  
  return (
    <Stack
      direction={{ mobile: url === 'chat' ? 'column-reverse' : 'column', laptop: 'row'}}
      sx={{ flex: 1 }}
    >
      <Input />
      <Divider orientation="vertical" flexItem light />
      <Output />
    </Stack>
  );
};

export default GeneratorContentPage;